
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/material-icons",
      function () {
        return require("private-next-pages/material-ui/material-icons.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/material-icons"])
      });
    }
  